import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import OfflineHome from './Pages/Home';
import OfflineDetails from './Pages/details';
import OfflineForm from './Pages/Form';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/offline-listing" replace />} />
                <Route path="/offline-listing" element={<OfflineHome />} />
                <Route path="/offline-listing/details/:listingId" element={<OfflineDetails />} />
                <Route path="/offline-listing/details/:listingId/form" element={<OfflineForm />} />
                <Route path="*" element={<Navigate to="/offline-listing" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
